import Vue from 'vue'

export const SET_CONFIGS = 'SET_CONFIGS'

export default {
  [SET_CONFIGS](state, configs) {
    Vue.set(state.configs, configs)
  },
}
